const EVIDENCE_KIND_LABELS: Record<string, string> = {
  text: 'Texto',
  image: 'Imagem',
  file: 'Arquivo',
  link: 'Link',
  qr_code: 'QR Code'
}

export const getEvidenceKindLabel = (kind?: string | null): string =>
  (kind && EVIDENCE_KIND_LABELS[kind]) || 'Texto'
